import styles from './ccf-interaction-email-icon.module.scss';
import { SvgIcon } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfInteractionEmailIconProps {}

/**
 * Component displays CcfInteractionEmailIcon Icon
 * @param props -CcfInteractionEmailIconProps
 * @returns CcfInteractionEmailIcon svg icon
 * @example <CcfInteractionEmailIcon/>
 */
export function CcfInteractionEmailIcon(props: CcfInteractionEmailIconProps) {
  return (
    <SvgIcon {...props}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.2 6.25714C14.96 6.08571 14.72 6 14.4 6H1.6C1.28 6 1.04 6.08571 0.8 6.25714L8 11.0571L15.2 6.25714Z"
          fill="#3498db"
        />
        <path
          d="M16 7.71429L8.4 12.7714C8.32 12.7714 8.16 12.8571 8 12.8571C7.84 12.8571 7.68 12.7714 7.6 12.6857L0 7.71429V16.2857C0 17.2286 0.72 18 1.6 18H14.4C15.28 18 16 17.2286 16 16.2857V7.71429Z"
          fill="#3498db"
        />
        <path
          d="M21.75 8.75C21.75 8.33578 21.4142 8 21 8C20.5858 8 20.25 8.33578 20.25 8.75V12H18.2732C18.0485 12 17.9202 12.2454 18.055 12.4174L20.7819 15.8957C20.8909 16.0348 21.1091 16.0348 21.2182 15.8957L23.945 12.4174C24.0798 12.2454 23.9515 12 23.7268 12H21.75V8.75Z"
          fill="#3498db"
        />
      </svg>
    </SvgIcon>
  );
}

export default CcfInteractionEmailIcon;
